<template>
  <el-container class="container">
    <NavBar :menuShow="menu_show"></NavBar>
    <el-container>
      <el-header height="110px" class="p-0 h-60" style="padding: 0;">
        <div class="flex flex-column head_tab">
          <div
            :style="{ 'background-color': headerTheme, width: '100%' }"
            class="p-0 h-60 flex head_tab_top"
          >
            <div
              class="text-center flex"
              style="line-height: 60px; align-items: center"
            >
              <i
                class="el-icon-s-fold font-sm text-white"
                v-show="menu_show"
                @click="showMenu"
              ></i>
              <i
                class="el-icon-s-unfold font-sm text-white"
                v-show="!menu_show"
                @click="showMenu"
              ></i>
            </div>
            <div class="flex" style="align-items: center">
              <breadcrumb />
            </div>
            <div class="theme">
              <theme-select></theme-select>
            </div>
            <div class="user">
              <user-opt></user-opt>
            </div>
          </div>
          <div style="width: 100%">
            <tab-view></tab-view>
          </div>
        </div>
      </el-header>
      <el-main style="background-color: #F1F0ED">
        <keep-alive :include="visitedViewList">
<!--          <div class="context">-->
            <router-view :key="key" />
<!--          </div>-->
        </keep-alive>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import NavBar from "@/layout/components/NavBar";
import ThemeSelect from "@/layout/components/ThemeSelect";
import UserOpt from "@/layout/components/UserOpt";
import Breadcrumb from "@/components/Breadcrumb";
import TabView from "@/components/TabView";

export default {
  name: "layout",
  components: {
    NavBar,
    ThemeSelect,
    UserOpt,
    Breadcrumb,
    TabView,
  },
  data() {
    return {
      menu_show: true,
    };
  },
  methods: {
    showMenu() {
      this.menu_show = !this.menu_show;
    },
  },
  computed: {
    ...mapGetters(["headerTheme"]),
    noCachedViewList() {
      return this.$store.state.tagsView.noCachedViewList;
    },
    visitedViewList() {
      return this.$store.state.tagsView.visitedViewList;
    },
    key() {
      return this.$route.fullPath;
    },
  },
};
</script>

<style scoped lang="scss">
.head_tab {
  align-items: center;
  box-sizing: border-box;
  flex-direction: column;
  .head_tab_top {
    align-items: center;
    box-sizing: border-box;
    padding-left: 20px;
    position: relative;
    .theme {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 210px;
    }
    .user {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0px;
    }
  }
}
//  /deep/ .el-main {
//   padding: 0;
// }
.context {
  height: 100%;
  // max-height: 82vh;
  max-width: 100%;
  // overflow-y: auto;
  overflow-x: hidden;
  // background: #577df3;
  &::-webkit-scrollbar {
    width: 5px;
    height: 10px;
    /**/
  }
  &::-webkit-scrollbar-track {
    background: rgb(239, 239, 239);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #333;
  }
  &::-webkit-scrollbar-corner {
    background: #179a16;
  }
}
</style>
